import { ErrorParser } from "../ErrorParser";
import { isObject } from "lodash-es";

/**
 * Ej: Dataset is empty
 */
export class ArchivoCasosVacioParser implements ErrorParser {
    public puedeLeerError(error: string): boolean {
        return !isObject(error) && error.includes("Dataset is empty");
    }

    public traducir(): string {
        return "El archivo de casos esta vacio";
    }
}
